import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { useTableStoreByRoute } from "@/stores/useTableStore";

import useAxiosPrivate from "../../../api/hooks/useAxiosPrivate";
import { ApiResources } from "../../../api/resources";
import { useAuth } from "../../../context/Auth/AuthProvider";
import { ROUTES } from "../../../shared";
import useResponse from "../../../shared/hooks/useResponse";
import { STEP_GROUP } from "../types";
import useTutorialMode from "./useTutorialMode";

const useHandleTutorialCompletion = (
  setTutorialCompanySelectorClose: (isOpen: boolean) => void
) => {
  const { clearTableHeadIfApplySchedule, setTutorialDetails } =
    useTutorialMode();

  const { putData } = useAxiosPrivate();
  const location = useLocation();
  const { getUserData } = useAuth();
  const { t } = useTranslation();
  const { handleCommonError } = useResponse();

  const { resetTableDetails } = useTableStoreByRoute(
    location.pathname as ROUTES
  );

  const handleTutorialCompletion = async (stepGroup: STEP_GROUP) => {
    try {
      await putData(ApiResources.UsersTutorials, {
        tutorials: [stepGroup]
      });

      setTutorialDetails({
        isTutorialOpen: false,
        stepIndex: 0,
        stepGroup: STEP_GROUP.Default,
        isTutorialActive: false
      });

      clearTableHeadIfApplySchedule();
      resetTableDetails();
      stepGroup === STEP_GROUP.TutorialCompanySelector &&
        setTutorialCompanySelectorClose(true); // call state change only if tutorial is for company selector
      await getUserData();
    } catch (error) {
      console.log(error);

      handleCommonError(error, t);
    }
  };

  return { handleTutorialCompletion };
};

export default useHandleTutorialCompletion;
